<template>
    <span style="display: flex;align-items: center;">
        <kl-label :title="title" :icon="icon" style="margin-right: 4px;" /><kl-label :title="value" :bold="bold" :type="type" />
    </span>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: ""
        },
        bold: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: ""
        },
    },
    computed: {

    }
}
</script>
<style lang="scss" scoped>
.iconfont {
    margin-right: 10px;
}
</style>